export function filterDataByDateRange(data, dateRange) {
    if (!data || data.length === 0) return data;
    if (dateRange === 'all') return data;

    const now = new Date();
    let cutoffDate;

    switch (dateRange) {
        case '7days':
            cutoffDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            break;
        case '1month':
            cutoffDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
            break;
        case '3months':
            cutoffDate = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
            break;
        case '6months':
            cutoffDate = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate());
            break;
        case '1year':
            cutoffDate = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
            break;
        default:
            return data;
    }

    return data.filter(item => {
        const itemDate = item.date instanceof Date ? item.date : new Date(item.date);
        return itemDate >= cutoffDate;
    });
}